import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faInfoCircle, faCheckCircle, faExclamationTriangle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

const ToastNotification = ({ id, message, type, onClose, duration = 5000 }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => onClose(id), 300);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, id, onClose]);

  const getColors = () => {
    switch (type) {
      case 'success':
        return 'bg-green-500 border-green-700';
      case 'error':
        return 'bg-red-500 border-red-700';
      case 'warning':
        return 'bg-yellow-500 border-yellow-700';
      default:
        return 'bg-blue-500 border-blue-700';
    }
  };

  const getIcon = () => {
    switch (type) {
      case 'success':
        return faCheckCircle;
      case 'error':
        return faExclamationCircle;
      case 'warning':
        return faExclamationTriangle;
      default:
        return faInfoCircle;
    }
  };

  return (
    <div
      className={`flex items-center justify-between p-4 rounded-lg shadow-lg text-white transition-all duration-300 transform ${getColors()} ${
        isVisible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'
      }`}
      style={{ minWidth: '250px', maxWidth: '350px' }}
    >
      <div className="flex items-center">
        <FontAwesomeIcon icon={getIcon()} className="mr-3 text-xl" />
        <span className="text-sm font-medium whitespace-normal break-words">{message}</span>
      </div>
      <button onClick={() => setIsVisible(false)} className="ml-4 text-white hover:text-gray-200 focus:outline-none">
        <FontAwesomeIcon icon={faTimes} />
      </button>
    </div>
  );
};

export default ToastNotification;